(function(){
  var MOTIVO = { 'Matrimonio':'por su matrimonio', 'Casa nueva':'para su casa nueva', 'Cumpleaños':'por su cumpleaños', 'Navidad':'para esta Navidad', 'Aniversario':'por su aniversario', 'Nacimiento':'por la llegada de su bebé', 'Agradecimiento':'como agradecimiento' };
  function init(root){
    var BOX_ID = Number(root.getAttribute('data-box-id'));
    var BOX_PRICE = Number(root.getAttribute('data-box-price'));
    var FREE_FROM = Number(root.getAttribute('data-free-from'));
    var BOX_NAME = root.getAttribute('data-box-name') || 'Caja de regalo Les Deux';
    var NOTE_D = root.getAttribute('data-note-digital') || '';
    var NOTE_B = root.getAttribute('data-note-box') || '';
    var LEAD = Number(root.getAttribute('data-lead-days')) || 2;
    var state = { format: root.getAttribute('data-default-format') || 'coffret', variant:null, price:0, occ:'', design:'barroco', dname:'Barroco' };
    var fmtCLP = function(n){ return '$' + Math.round(n).toLocaleString('es-CL'); };
    var q = function(s){ return root.querySelector(s); };
    var qa = function(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); };
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function iso(d){ return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    function cl(v){ var p = v.split('-'); return p[2] + '-' + p[1] + '-' + p[0]; }
    function minDate(){
      var d = new Date(), n = 0;
      while(n < LEAD){ d.setDate(d.getDate() + 1); var w = d.getDay(); if(w !== 0 && w !== 6){ n++; } }
      return iso(d);
    }
    function phoneOk(v){ return v.replace(/\D/g, '').length >= 8; }
    function setGroup(nodes, active){
      nodes.forEach(function(n){ var on = n === active; n.classList.toggle('is-on', on); n.setAttribute('aria-checked', on ? 'true' : 'false'); });
    }
    function render(){
      var digital = state.format === 'digital';
      qa('[data-show]').forEach(function(el){ el.hidden = el.getAttribute('data-show') !== state.format; });
      var box = digital ? 0 : (state.price >= FREE_FROM ? 0 : BOX_PRICE);
      qa('[data-sum="amount"]').forEach(function(el){ el.textContent = fmtCLP(state.price); });
      q('[data-sum="fmtname"]').textContent = digital ? 'Envío por email' : BOX_NAME;
      q('[data-sum="box"]').textContent = digital ? 'Incluido' : (box === 0 ? 'Gratis' : fmtCLP(box));
      q('[data-sum="total"]').textContent = fmtCLP(state.price + box);
      q('[data-sum="note"]').textContent = digital ? NOTE_D : NOTE_B;
    }
    var fmts = qa('.lg-fmt');
    fmts.forEach(function(b){ b.addEventListener('click', function(){ state.format = b.getAttribute('data-format'); setGroup(fmts, b); render(); }); });
    var pills = qa('[data-variant]');
    pills.forEach(function(b){ b.addEventListener('click', function(){ state.variant = b.getAttribute('data-variant'); state.price = Number(b.getAttribute('data-price')) / 100; setGroup(pills, b); render(); }); });
    var occs = qa('[data-occ]');
    occs.forEach(function(b){ b.addEventListener('click', function(){ var v = b.getAttribute('data-occ'); if(state.occ === v){ state.occ = ''; setGroup(occs, null); } else { state.occ = v; setGroup(occs, b); } }); });
    var dsgs = qa('[data-design]');
    dsgs.forEach(function(b){ b.addEventListener('click', function(){
      state.design = b.getAttribute('data-design'); state.dname = b.getAttribute('data-name'); setGroup(dsgs, b);
      var th = q('[data-sum="thumb"]'); if(th){ th.style.backgroundPosition = b.getAttribute('data-pos') + '% 0'; }
      var sd = q('[data-sum="design"]'); if(sd){ sd.textContent = state.dname; }
    }); });
    var first = q('[data-variant].is-on') || pills[0];
    if(first){ state.variant = first.getAttribute('data-variant'); state.price = Number(first.getAttribute('data-price')) / 100; }
    var form = q('[data-ldgc-form]');
    var MIN = minDate();
    if(form.elements.fecha_caja){ form.elements.fecha_caja.min = MIN; }
    if(form.elements.fecha){ form.elements.fecha.min = iso(new Date()); }
    render();
    var err = q('[data-err]');
    function fail(msg, field){
      err.textContent = msg; err.hidden = false;
      if(field && field.focus){ field.focus(); }
    }
    form.addEventListener('submit', function(e){
      e.preventDefault();
      err.hidden = true;
      var f = form.elements;
      var props = { 'Formato': state.format === 'digital' ? 'Digital' : BOX_NAME };
      if(f.para.value) props['Para'] = f.para.value.trim();
      if(f.de.value) props['De'] = f.de.value.trim();
      if(state.occ) props['Ocasión'] = MOTIVO[state.occ] || state.occ;
      if(state.format === 'digital') props['Diseño'] = state.dname;
      var items = [];
      if(state.format === 'digital'){
        var email = f.email.value.trim();
        if(email){
          if(email !== f.email2.value.trim()){ return fail('Los emails no coinciden.', f.email2); }
          props['Recipient email'] = email;
          props['__shopify_send_gift_card_to_recipient'] = 'on';
          if(f.para.value) props['Recipient name'] = f.para.value.trim();
          var msg = f.mensaje.value.trim(), firma = f.de.value.trim();
          if(msg || firma){ props['Message'] = msg ? (firma ? msg + '\n— ' + firma : msg) : 'Con cariño, ' + firma + '.'; }
          if(f.fecha.value) props['Send on'] = f.fecha.value;
        }
        items.push({ id: Number(state.variant), quantity: 1, properties: props });
      } else {
        if(!f.para.value.trim()){ return fail('Indica para quién es la caja.', f.para); }
        if(!f.contacto.value.trim()){ return fail('Indica la persona de contacto para la entrega o retiro.', f.contacto); }
        if(!phoneOk(f.contacto_tel.value)){ return fail('Falta el teléfono de contacto para la entrega.', f.contacto_tel); }
        var fecha = f.fecha_caja.value;
        if(!fecha){ return fail('Elige para cuándo la necesitas.', f.fecha_caja); }
        if(fecha < MIN){ return fail('Necesitamos al menos ' + LEAD + ' días hábiles para prepararla. La primera fecha disponible es el ' + cl(MIN) + '.', f.fecha_caja); }
        var boxProps = { 'Para gift card de': fmtCLP(state.price), 'Para': f.para.value.trim() };
        if(f.de.value.trim()) boxProps['De'] = f.de.value.trim();
        if(state.occ) boxProps['Ocasión'] = state.occ;
        boxProps['Contacto entrega'] = f.contacto.value.trim();
        boxProps['Teléfono contacto'] = f.contacto_tel.value.trim();
        if(f.contacto_email.value.trim()) boxProps['Email contacto'] = f.contacto_email.value.trim();
        if(f.indicaciones.value.trim()) boxProps['Indicaciones'] = f.indicaciones.value.trim();
        boxProps['Fecha límite'] = cl(fecha);
        if(f.nota.value) props['Nota manuscrita'] = f.nota.value.trim();
        items.push({ id: Number(state.variant), quantity: 1, properties: props });
        items.push({ id: BOX_ID, quantity: 1, properties: boxProps });
      }
      fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function(r){ return r.json().then(function(d){ return { ok:r.ok, d:d }; }); })
        .then(function(res){
          if(res.ok){ window.location.href = '/cart'; return; }
          fail(state.format === 'coffret'
            ? 'La ' + BOX_NAME + ' aún no está disponible. Puedes elegir la gift card digital.'
            : (res.d && res.d.description) || 'No pudimos agregarla al carro. Inténtalo de nuevo.');
        })
        .catch(function(){ fail('No pudimos agregarla al carro. Inténtalo de nuevo.'); });
    });
  }
  function boot(){ Array.prototype.forEach.call(document.querySelectorAll('[data-ldgc]'), init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
